let isProcessing = false;

function removeDuplicateImages() {
    if (isProcessing) return;
    isProcessing = true;

    try {
        const mediaLists = document.querySelectorAll('.product__media-list');
        const thumbnailLists = document.querySelectorAll('.thumbnail-list');

        mediaLists.forEach((mediaList, index) => {
            const mediaItems = mediaList.querySelectorAll('.product__media-item');
            const thumbnailItems = thumbnailLists[index]?.querySelectorAll('.thumbnail-list__item');
            const uniqueImages = new Map();
            const processedUrls = new Set();
            let hasRemovedItems = false;

            mediaItems.forEach((item, i) => {
                if (item.id.includes('template-placeholder')) return;

                const img = item.querySelector('.product__media img');
                if (!img) return;

                const url = (img.src || img.dataset.src || '').split('?')[0];
                if (!url) return;

                const baseProductName = url
                    .split('/')
                    .pop()
                    .replace(/[-_]\d+/g, '')
                    .replace(/\.\w+$/, '')
                    .replace(/_+$/, '')
                    .toLowerCase();

                if (!processedUrls.has(baseProductName)) {
                    processedUrls.add(baseProductName);
                    uniqueImages.set(baseProductName, {
                        mediaItem: item,
                        thumbnailItem: thumbnailItems?.[i]
                    });
                } else {
                    item.classList.add('duplicate-for-removal');
                    if (thumbnailItems?.[i]) {
                        thumbnailItems[i].classList.add('duplicate-for-removal');
                    }
                    hasRemovedItems = true;
                }
            });

            if (hasRemovedItems) {
                const sliderComponent = mediaList.closest('slider-component');

                // Remove duplicates
                mediaList.querySelectorAll('.duplicate-for-removal').forEach(item => item.remove());
                thumbnailLists[index]?.querySelectorAll('.duplicate-for-removal').forEach(item => item.remove());

                if (sliderComponent) {
                    // Completely reinitialize the slider
                    setTimeout(() => {
                        // Reset core properties
                        sliderComponent.slider = sliderComponent.querySelector('[id^="Slider-"]');
                        sliderComponent.sliderItems = sliderComponent.querySelectorAll('[id^="Slide-"]');
                        sliderComponent.currentPage = 1;
                        sliderComponent.sliderItemOffset = null;

                        // Reinitialize core functionality
                        if (sliderComponent.slider) {
                            sliderComponent.slider.scrollLeft = 0;
                            sliderComponent.initPages();
                            sliderComponent.update();

                            // Reattach event listeners
                            sliderComponent.slider.addEventListener('scroll', sliderComponent.update.bind(sliderComponent));
                            sliderComponent.prevButton?.addEventListener('click', sliderComponent.onButtonClick.bind(sliderComponent));
                            sliderComponent.nextButton?.addEventListener('click', sliderComponent.onButtonClick.bind(sliderComponent));

                            if (sliderComponent.dotsContainer) {
                                sliderComponent.updateDots();
                                sliderComponent.dotsContainer.addEventListener('click', sliderComponent.onDotClick.bind(sliderComponent));
                            }
                        }
                    }, 100);
                }
            }
        });
    } finally {
        isProcessing = false;
    }
}

function updateSliderCounters(mediaList) {
    const totalItems = mediaList.querySelectorAll('.product__media-item').length;
    const counterTotal = mediaList.querySelector('.slider-counter--total');
    if (counterTotal) {
        counterTotal.textContent = totalItems;
    }
}

// Debounce function to limit execution frequency
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

// Add debounced event listeners
const debouncedRemoveDuplicates = debounce(removeDuplicateImages, 250);

document.addEventListener('DOMContentLoaded', debouncedRemoveDuplicates);
document.addEventListener('shopify:section:load', debouncedRemoveDuplicates);
document.addEventListener('variant:change', debouncedRemoveDuplicates);

// Display thumbnail slider function
// Debug helper
function showThumbnailSlider() {
    const thumbnailSliders = document.querySelectorAll('.thumbnail-slider');
    
    if (!thumbnailSliders.length) {
        return;
    }

    thumbnailSliders.forEach(slider => {
        if (!slider.style.display || slider.style.display === 'none') {
            setTimeout(() => {
                slider.style.display = 'flex';
            }, 400);
        }
    });
}

function observeThumbnailSliderChanges() {
    const thumbnailSliders = document.querySelectorAll('.thumbnail-slider');
    
    if (!thumbnailSliders.length) {
        return;
    }

    thumbnailSliders.forEach(slider => {
        if (slider.dataset.hasObserver) return;
        
        const observer = new MutationObserver(() => {
            setTimeout(showThumbnailSlider, 400);
        });

        observer.observe(slider, {
            childList: true,
            subtree: true,
            attributes: true
        });
        
        slider.dataset.hasObserver = 'true';
    });
}

function initialize() {
    showThumbnailSlider();
    observeThumbnailSliderChanges();
}

document.addEventListener('DOMContentLoaded', initialize);
document.addEventListener('shopify:section:load', initialize);
document.addEventListener('variant:change', initialize);

if (document.readyState === 'complete') {
    initialize();
}
